import React, { useContext } from 'react';
import { Nav, Navbar, NavbarText } from "reactstrap";
import { NavLink } from 'react-router-dom'

import { AuthContext } from "@meddbriefer/mdb-auth"

import UserDropDown from "./UserDropDown"

import "../index.css";


export function MDBNavBar({title, leftNav = null, rightNav = null }) {
    const { isAuthenticated } = useContext(AuthContext)

    return (
        <Navbar>
            <NavbarText className="brand-wrapper">
                <NavLink to="/" className="brand">
                    MedDBriefer
                </NavLink>
            </NavbarText>

            {!!leftNav &&
                <Nav>
                {leftNav}
                </Nav>
            }

            {!!title &&
                <NavbarText className="mr-auto mdb-title">  {title} </NavbarText>
            }

            <Nav>
                {!!rightNav && rightNav}
            </Nav>
            <Nav>
                <UserDropDown show={isAuthenticated} />
            </Nav>
        </Navbar>
    )
}
